import React, { useState, useEffect } from 'react';
import "../Admin/css/payment.css";
import "../Admin/css/layout.css";
import Sidebar from './Sidebar';
import Header from './Header';
import { secureStorage } from '../utils/secureStorage';
import receiptLogo from "../Admin/logo/mathangi_logo.png";
import { FaEye } from "react-icons/fa";
import { FaReceipt } from "react-icons/fa";
import {FaWallet, FaCheckCircle,FaClock,FaExchangeAlt} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {getPayments } from "../service/paymentService.js";
import { FaTimes } from "react-icons/fa";
import { FaGift } from "react-icons/fa";

const Payment = () => {
   const navigate = useNavigate();
  const [selectedPayment, setSelectedPayment] = useState(null);
const [showModal, setShowModal] = useState(false);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastPayment, setLastPayment] = useState(null);
  const [stats, setStats] = useState({
    totalAmount:0,
    totalPaid: 0,
    totalPending: 0,
    totalTransactions: 0,
    total_referral_amt: 0
  });
  const [showReceiptModal, setShowReceiptModal] = useState(false);
const [receiptData, setReceiptData] = useState(null);
const [currentPage, setCurrentPage] = useState(1);
const paymentsPerPage = 10;



  // Get scholar info from secureStorage
  const scholar = secureStorage.getScholar();

  const calculateStats = (paymentData) => {
  if (!paymentData || paymentData.length === 0) {
    setStats({
      totalAmount: 0,
      totalPaid: 0,
      totalPending: 0,
      totalTransactions: 0,
      total_referral_amt: 0,
    });
    return;
  }

  
  // latest payment record
  const latestPayment = paymentData[0];
   const totalReferralAmount = paymentData.reduce(
    (sum, payment) =>
      sum + Number(payment.total_referral_amt || 0),
    0
  );

  setStats({
    totalAmount: parseFloat(latestPayment.total_amount || 0),

    // total paid from API
    totalPaid: parseFloat(latestPayment.tot_paid || 0),

    // balance amount from API
    totalPending: parseFloat(latestPayment.bal_amt || 0),

    totalTransactions: paymentData.length,  
    total_referral_amt: totalReferralAmount,
  });
};

  // Format payment data for display
  const formatPayments = (paymentData) => {
    return paymentData.map(payment => ({
      id: payment.id,
      date: new Date(payment.pay_dt_tm).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }),
      description: payment?.purpose?.pay_purpose || "Payment",
      amount: `₹${parseFloat(payment.pay_received).toLocaleString('en-IN')}`,
      totalAmount: parseFloat(payment.total_amount),
      balance: parseFloat(payment.bal_amt),
     method: payment?.bank?.bank_nm || "N/A",
      status: payment.pay_status,
      reg_id: payment.reg_id,
      user_id: payment.user_id,
      pay_dt_tm: payment.pay_dt_tm,
        lastPayment: payment.pay_received,
         // KEEP SAME NAME AS API
    referral_data: payment.referral_data || [],
    total_referral_amt: payment.total_referral_amt || 0,
    
    }));
  };

  

 const fetchPayments = async () => {
  try {
    setLoading(true);
    setError(null);

    // Get scholar ID
    const scholarId = scholar?.id;

    if (!scholarId) {
      throw new Error("Scholar information not found");
    }

    // API Call
    const resData = await getPayments(scholarId);

    // Payment Data
    const paymentData =
      resData?.data?.data || resData?.data || [];

    if (Array.isArray(paymentData) && paymentData.length > 0) {
      calculateStats(paymentData);

      const formattedPayments =
        formatPayments(paymentData);

      setPayments(formattedPayments);
    } else {
      setPayments([]);
      calculateStats([]);
    }

  } catch (error) {
    console.error("Error fetching payments:", error);

    setError(
      error.message || "Failed to load payment data"
    );

    setPayments([]);
    calculateStats([]);

  } finally {
    setLoading(false);
  }
};

  const handleViewDetails = (payment) => {
  setSelectedPayment(payment);
  setShowModal(true);
};


const closeModal = () => {
  setShowModal(false);
  setSelectedPayment(null);
};
  // Handle download receipt
const handleDownloadReceipt = (payment) => {
  setReceiptData(payment);
  setShowReceiptModal(true);
};
const handlePrintReceipt = () => {
  window.print();
};
  

  // Fetch payments on component mount
  useEffect(() => {
    if (scholar?.id) {
      fetchPayments();
    } else {
      setLoading(false);
      setError("Scholar information not available");
    }
  }, [scholar?.id]);

  // Stats cards data with proper formatting
  const statsCards = [
    
     { 
      label: "Total Amount", 
      value: `₹${stats.totalAmount.toLocaleString('en-IN')}`, 
      icon:  <FaWallet />,
      color: "#e71717"
    },
    { 
      label: "Total Paid", 
      value: `₹${stats.totalPaid.toLocaleString('en-IN')}`, 
      icon: <FaCheckCircle />,
      color: "#28a745"
    },
    { 
      label: "Outstanding Balance", 
      value: `₹${stats.totalPending.toLocaleString('en-IN')}`, 
      icon: <FaClock />,
      color: "#ffc107"
    },
    { 
      label: "Total Transactions", 
      value: stats.totalTransactions, 
      icon:  <FaExchangeAlt />,
      color: "#007bff"
    },
    ...(Number(stats.total_referral_amt) > 0
    ? [
        {
          label: "Total Referral Amount",
          value: `₹${stats.total_referral_amt.toLocaleString("en-IN")}`,
          icon: <FaClock />,
          color: "#ffc107",
        },
      ]
    : []),
];
  // Pagination Logic
const indexOfLastPayment = currentPage * paymentsPerPage;

const indexOfFirstPayment =
  indexOfLastPayment - paymentsPerPage;

const currentPayments = payments.slice(
  indexOfFirstPayment,
  indexOfLastPayment
);

const totalPages = Math.ceil(
  payments.length / paymentsPerPage
);

useEffect(() => {
  const scholar = secureStorage.getScholar();

  if (!scholar) {
    navigate("/", { replace: true });
  }
}, [navigate]);

  // Loading state
   if (loading) {
    return (
      <>
        <div className="layout">
          <Sidebar />
          <div className="main-area">
            <Header />
        <div className="modern-loader-container">
     <div className="modern-loader-card">
    <div className="modern-loader-animation">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <h3>Loading Payments</h3>
    <p>Please wait while we fetch your payment details...</p>
  </div>
</div>
          </div>
        </div>
      </>
    );
  }
  

  // Error state
  if (error) {
    return (
      <>
        <div className="layout">
          <Sidebar />
          <div className="main-area">
            <Header />
            <div className="payment-container">
              <div className="error-container">
                <div className="error-icon">⚠️</div>
                <h3>Error Loading Payments</h3>
                <p>{error}</p>
                <button onClick={fetchPayments} className="retry-button">
                  Try Again
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
   <>
     <div className="layout">
        <Sidebar/>
         <div className="main-area">
            <Header/>
            <div className='payment-top-container'>
     <div className="payment-container">
      <h1>Payment History</h1>
      <p className="subtitle">View and manage your payment transactions</p>

      {/* Stats Cards */}
            <div className="stats">
              {statsCards.map((s, i) => (
                <div key={i} className={`modern-stat-card ${s.className}`}>
                  <div className="modern-icon">{s.icon}</div>
                   <div className="modern-stat-content">
                  <p>{s.label}</p>
                  <h2>{s.value}</h2>
                  </div>
                </div>
              ))}
            </div>

       {/* Payment Table */}
            {payments.length > 0 ? (
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Payment Purpose</th>
                      <th>Amount Paid</th>
                      {/* <th>Total Amount</th> */}
                      {/* <th>Balance</th> */}
                      <th>Bank</th>
                      <th>Status</th>
                      <th>View</th>
                      <th>Invoice</th>
                    </tr>
                  </thead>
                  <tbody>
                   {currentPayments.map((payment, i) => (
                      <tr key={payment.id || i}>
                        <td>{payment.date}</td>
                        <td>{payment.description}</td>
                        {/* <td className="amount-paid">{payment.amount}</td> */}
                        <td className="amount-paid">
  <strong className="paid-amount">
   {payment.amount}
  </strong>

  {Number(payment.total_referral_amt) > 0 && (
    <div
      style={{
    marginTop: "4px",
    color: "red",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  }}
    >
         <FaGift />
      {Number(payment.total_referral_amt).toLocaleString("en-IN")}
    </div>
  )}
</td>
                        {/* <td>₹{payment.totalAmount.toLocaleString('en-IN')}</td> */}
                        {/* <td className="balance-amount">
                          ₹{payment.balance.toLocaleString('en-IN')}
                        </td> */}
                        <td>{payment.method}</td>
                        
                        
                         <td>
                        <span
                          className={`badge ${
                            payment.status === "approved"
                              ? "approved"
                              : payment.status === "rejected"
                              ? "rejected"
                              : "pending"
                          }`}
                        >
                          {payment.status === "approved"
                            ? "Approved"
                            : payment.status === "rejected"
                            ? "Rejected"
                            : "Pending"}
                        </span>
                      </td>
                        
                        <td>
                          <button
                            className="iconss"
                            onClick={() => handleViewDetails(payment)}
                            title="View Details"
                          >
                            <FaEye />
                          </button>
                          </td>
                          <td>
                          <button
                            className="iconss"
                            onClick={() => handleDownloadReceipt(payment)}
                            title="Download Receipt"
                          >
                            <FaReceipt />
                          </button>
                        </td>
                      </tr>
                    ))}
                   
                    {showReceiptModal && receiptData && (
  <div className="modal-overlay" onClick={() => setShowReceiptModal(false)}>
    <div className="receipt-modal" onClick={(e) => e.stopPropagation()}>
       <button
    className="receipt-close-icon"
    onClick={() => setShowReceiptModal(false)}
  >
    <FaTimes />
  </button>
      <div className='receipt-logo'>
        <img src={receiptLogo} alt="Maathangi Scholar Portal" />
      </div>
      <div className="receipt-info">
            <h2>Maathangi Info Research Solutions Pvt Ltd.,</h2>
            <p>JJ Arcade, 1st Floor, Near New Bus Stand,
              Marthandam - Kanyakumari District,
              Tamil Nadu - 629165</p>
        </div>
      <div className="receipt-header">
        <h2>Payment Receipt</h2>
      
      </div>
     <div className="receipt-details">

  <div className="receipt-details-header">
    <h3>Scholar Details</h3>
  </div>

  <div className="receipt-details-grid">

    <div className="detail-card">
      <span className="detail-label">Scholar Name</span>
      <p className="detail-value">
        {scholar?.user_name || "N/A"}
        <br></br>
        {scholar?.user_id || "N/A"}
      </p>
    </div>

    <div className="detail-card">
      <span className="detail-label">Email Address</span>
      <p className="detail-value">
        {scholar?.email || "N/A"}
      </p>
    </div>

    <div className="detail-card">
      <span className="detail-label">Phone Number</span>
      <p className="detail-value">
        {scholar?.contact || "N/A"}
      </p>
    </div>

  </div>

</div>
 <div className="receipt-row"></div>
<br></br>
<div className='recepit-work-details'>
  <h3>Work Description</h3>
  <p>{scholar?.work_description || "N/A"}</p>
</div>
 <div className="receipt-row"></div>
                      <br></br>
                      <div className='recepit-body-1'>
                        <h3>Payment Details</h3>
                      </div>
<br></br>
      <div className="receipt-body">
        

        <div className="receipt-row">
          <span>Date</span>
          <strong>{receiptData.date}</strong>
        </div>

        <div className="receipt-row">
          <span>Purpose</span>
          <strong>{receiptData.description}</strong>
        </div>

        <div className="receipt-row">
          <span>Amount Paid</span>
          <strong className="paid-amount">{receiptData.amount}</strong>
        </div>

        <div className="receipt-row">
          <span>Total Amount</span>
          <strong>
            ₹{receiptData.totalAmount.toLocaleString("en-IN")}
          </strong>
        </div>

        <div className="receipt-row">
          <span>Balance</span>
          <strong className="balance-amount-red">
            ₹{receiptData.balance.toLocaleString("en-IN")}
          </strong>
        </div>
       {Number(receiptData.total_referral_amt) > 0 && (
  <div className="receipt-row">
    <span>Total Referral Amount</span>
    <strong className="paid-amount">
      ₹{Number(receiptData.total_referral_amt).toLocaleString("en-IN")}
    </strong>
  </div>
)}    

        <div className="receipt-row">
          <span>Bank</span>
          <strong>{receiptData.method}</strong>
        </div>

        <div className="receipt-row">
          <span>Status</span>

          <strong
            className={
              receiptData.status === "approved"
                ? "approved-text"
                : receiptData.status === "rejected"
                ? "rejected-text"
                : "pending-text"
            }
          >
            {receiptData.status}
          </strong>
        </div>
      </div>

      <div className="receipt-buttons">
        <button
          className="closes-btn"
          onClick={() => setShowReceiptModal(false)}
        >
          Close
        </button>
         {/* <button
          className="print-btn"
          onClick={handlePrintReceipt}
        >
          Print
        </button> */}
      </div>
    </div>
  </div>
)}
                    {showModal && selectedPayment && (
  <div className="modal-overlays" onClick={closeModal}>
    <div className="modal-box dark-md-clr"   onClick={(e) => e.stopPropagation()}>
      <h2>Payment Details</h2>

    <div className="modal-content dark-md-clr">
  <div className="info-card">
    <strong>Date</strong>
    <span>{selectedPayment.date}</span>
  </div>

  <div className="info-card">
    <strong>Description</strong>
    <span>{selectedPayment.description}</span>
  </div>

  <div className="info-card">
    <strong>Total Amount</strong>
    <span>₹{selectedPayment.totalAmount.toLocaleString('en-IN')}</span>
  </div>

  <div className="info-card">
    <strong>Amount Paid</strong>
    <span className="paid-amount">{selectedPayment.amount}</span>
  </div>
  

  <div className="info-card">
    <strong>Balance</strong>
    <span className="balance-amount">
      ₹{selectedPayment.balance.toLocaleString('en-IN')}
    </span>
  </div>

  <div className="info-card">
    <strong>Bank</strong>
    <span>{selectedPayment.method}</span>
  </div>

  <div className="info-card">
    <strong>Status</strong>
    <span
      className={
        selectedPayment.status === "approved"
          ? "approved-text"
          : selectedPayment.status === "rejected"
          ? "rejected-text"
          : "pending-text"
      }
    >
      {selectedPayment.status}
    </span>
  </div>
 <div className="info-card">
  <strong>Last Payment</strong>
  <span>
    ₹{parseFloat(selectedPayment.lastPayment || 0).toLocaleString("en-IN")}
  </span>
</div>
{Number(selectedPayment?.total_referral_amt) > 0 && (
  <div className="info-card">
    <strong>Total Referral Amount</strong>
    <span>
      ₹{Number(selectedPayment.total_referral_amt).toLocaleString("en-IN")}
    </span>
  </div>  
)}
</div>
{selectedPayment.referral_data?.length > 0 && (
  <>
    <h3 style={{ marginTop: "20px" }}>    
      Referral Details
    </h3>

    <table className="table referral-table">
      <thead>
        <tr>
          <th>Referred Person</th>
          <th>Referral Amount</th>
          <th>Reason</th>   
          <th>Date</th>
          <th>Status</th>
        </tr>
      </thead>

      <tbody>
        {selectedPayment.referral_data.map((ref) => (
          <tr key={ref.id}>
            <td>{ref.referred_person}</td>
            <td>
  ₹{Number(ref.referral_amount || 0).toLocaleString("en-IN")}
</td>
            <td>{ref.referral_reason || "-"}</td>
            <td>{ref.referral_date}</td>
            <td>{ref.referral_status}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </>
)}
      <button className="close-btn" onClick={closeModal}>Close</button>
    </div>
  </div>
)}
                  </tbody>
                   <div className="pagination">
                    <button
                      onClick={() => setCurrentPage(currentPage - 1)}
                      disabled={currentPage === 1}
                      className="page-btn"
                    >
                      Previous
                    </button>

                    {[...Array(totalPages)].map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentPage(index + 1)}
                        className={
                          currentPage === index + 1
                            ? "page-btn active-page"
                            : "page-btn"
                        }
                      >
                        {index + 1}
                      </button>
                    ))}

                    <button
                      onClick={() => setCurrentPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className="page-btn"
                    >
                      Next
                    </button>
                  </div>
                </table>
              </div>
            ) : (
              <div className="no-payments">
                <div className="no-payments-icon">💳</div>
                <h3>No Payment Records Found</h3>
                <p>You haven't made any payments yet.</p>
              </div>
            )}
          </div>
        </div>
      </div>
      </div>
   </>
  )
}

export default Payment